"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.cloneModule = function (mod) {
    return __assign(__assign({}, mod), { blocks: __assign({}, mod.blocks) });
};
exports.Set = function (block) { return ({ type: "Set", data: block }); };
exports.Remove = function (block) { return ({
    type: "Remove",
    data: block
}); };
exports.ModuleReducer = function (state, action) {
    switch (action.type) {
        case "Set": {
            var nextState = exports.cloneModule(state);
            nextState.blocks[action.data.id] = action.data;
            return nextState;
        }
        case "Remove": {
            var nextState = exports.cloneModule(state);
            delete nextState.blocks[action.data.id];
            return nextState;
        }
    }
};
exports.useModule = function (data, rootId) {
    var _a = react_1.useReducer(exports.ModuleReducer, {
        rootId: rootId,
        blocks: data
    }), mod = _a[0], dispatch = _a[1];
    var SetBlock = function (block) { return dispatch(exports.Set(block)); };
    var RomoveBlock = function (block) { return dispatch(exports.Remove(block)); };
    return [mod, SetBlock, RomoveBlock];
};
